import { atom } from 'recoil';

export const openJobtitleCreateModalAtom = atom<number | null>({
	key: 'openJobtitleCreateModal',
	default: null,
});
